var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGainsight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5B6670",
    fillRule: "evenodd",
    d: "m33.5 18.457-4.891 4.42v-.093h-7.38v-4.488H33.5zM16.12 34.158C10.17 32.15 6.5 26.741 6.5 20.086v-.483C6.613 11.449 13.285 4.916 21.4 5c5.06 0 8.142 1.42 11.11 3.949l-3.194 3.863a11.27 11.27 0 0 0-8.114-3.096c-5.316 0-9.359 4.687-9.359 10.227v.085c0 5.546 3.34 9.706 8.52 10.297l-4.243 3.832Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B2E3",
    fillRule: "evenodd",
    d: "M33.5 18.302v12.153A18.25 18.25 0 0 1 21.456 35c-1.978 0-3.808-.31-5.46-.884l4.216-3.809q.698.09 1.442.09a11.76 11.76 0 0 0 6.955-2.187v-5.426h-.07z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGainsight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gainsight.cd739a50.svg";